(() => {
  if (window.beginnerValuesModalInitialized) return;
  window.beginnerValuesModalInitialized = true;

  const syncPageScroll = () => {
    const hasOpenDialog = document.querySelector('.beginner-values__dialog[open]');
    document.documentElement.classList.toggle('beginner-modal-open', Boolean(hasOpenDialog));
  };

  const closeDialog = (dialog) => {
    if (!dialog?.open) return;
    dialog.close();
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-beginner-modal-open]');

    if (opener) {
      const dialog = document.getElementById(opener.dataset.beginnerModalOpen);

      if (dialog && typeof dialog.showModal === 'function') {
        dialog._beginnerOpener = opener;
        dialog.showModal();
        syncPageScroll();
      }
      return;
    }

    const closeButton = event.target.closest('[data-beginner-modal-close]');

    if (closeButton) {
      closeDialog(closeButton.closest('.beginner-values__dialog'));
      return;
    }

    const dialog = event.target.closest('.beginner-values__dialog');

    if (dialog && event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      const isOutside =
        event.clientX < bounds.left ||
        event.clientX > bounds.right ||
        event.clientY < bounds.top ||
        event.clientY > bounds.bottom;

      if (isOutside) closeDialog(dialog);
    }
  });

  document.addEventListener('close', (event) => {
    const dialog = event.target;
    if (!dialog.matches?.('.beginner-values__dialog')) return;

    syncPageScroll();
    dialog._beginnerOpener?.focus();
    dialog._beginnerOpener = null;
  }, true);
})();
